import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import configJson from 'config/config.json';
import packageJson from '../../package.json';

const isProd = process.env.NODE_ENV === 'production';

const sentryReduxEnhancerProd = Sentry.createReduxEnhancer({
  actionTransformer: (action) => {
    if (!action.type.includes('FAILURE')) return null;

    return action;
  },
});

export const sentryReduxEnhancer = isProd
  ? sentryReduxEnhancerProd
  : (next) => (reducer, initialState) => next(reducer, initialState);

if (isProd) {
  Sentry.init({
    dsn: 'https://96765a7f993640e3bd7cceefe320cc15@o308676.ingest.sentry.io/5719070',
    release: `${configJson.stage}.${packageJson.version}`,
    ignoreErrors: [
      /toBufferBlock/i,
      /Your wallet network is not the same as in/i,
      /User denied account/i,
      /denied the transaction/i,
      /errors.no_accounts_locked/i,
      /'errors.wrong_network'/i,
      /'errors.provider_not_approved'/i,
    ],
    denyUrls: [/extensions\//i, /^chrome:\/\//i],
    integrations: [
      new Integrations.BrowserTracing(),
      new Sentry.Integrations.Breadcrumbs({
        console: false,
        beacon: false,
        dom: false,
        fetch: false,
        xhr: false,
      }),
    ],
  });
}
